import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

export default function DatenschutzPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="datenschutz-page">
      <section className="py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={fadeUp}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-3xl sm:text-4xl font-bold text-zinc-950 tracking-tight mb-8">
              Datenschutzerklärung
            </h1>

            <div className="prose prose-zinc max-w-none">
              <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">
                1. Datenschutz auf einen Blick
              </h2>
              
              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">Allgemeine Hinweise</h3>
              <p className="text-zinc-600 mb-4">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
                personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
                Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              </p>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">Datenerfassung auf dieser Website</h3>
              <p className="text-zinc-600 mb-4">
                <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber:
              </p>
              <div className="bg-zinc-50 rounded-xl p-6 border border-zinc-100 mb-4">
                <p className="text-zinc-600">
                  Rent Mich AT / Jakov Domitrek<br />
                  Wagnerweg 8<br />
                  4202 Sonnberg im Mühlkreis<br />
                  Österreich<br />
                  E-Mail: info@rentmich.at
                </p>
              </div>

              <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">
                2. Allgemeine Hinweise und Pflichtinformationen
              </h2>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">Datenschutz</h3>
              <p className="text-zinc-600 mb-4">
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
                Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen 
                Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">Hinweis zur verantwortlichen Stelle</h3>
              <p className="text-zinc-600 mb-4">
                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder 
                gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen 
                Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
              </p>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">Speicherdauer</h3>
              <p className="text-zinc-600 mb-4">
                Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt 
                wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die 
                Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen 
                oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, 
                sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer 
                personenbezogenen Daten haben.
              </p>

              <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">
                3. Datenerfassung auf dieser Website
              </h2>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">Kontaktformular</h3>
              <p className="text-zinc-600 mb-4">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus 
                dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks 
                Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. 
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
              <p className="text-zinc-600 mb-4">
                Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, 
                sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur 
                Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen 
                beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven 
                Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf 
                Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
              </p>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">Buchungsanfragen</h3>
              <p className="text-zinc-600 mb-4">
                Bei Buchungsanfragen für unsere Mietartikel erfassen wir folgende Daten:
              </p>
              <ul className="list-disc list-inside text-zinc-600 mb-4">
                <li>Vor- und Nachname</li>
                <li>E-Mail-Adresse</li>
                <li>Telefonnummer</li>
                <li>Gewünschter Mietzeitraum</li>
                <li>Gewählte Produktvariante</li>
                <li>Optionale Nachricht</li>
              </ul>
              <p className="text-zinc-600 mb-4">
                Diese Daten werden ausschließlich zur Bearbeitung Ihrer Buchungsanfrage verwendet 
                und nach Abschluss des Mietvorgangs gemäß den gesetzlichen Aufbewahrungsfristen 
                gespeichert.
              </p>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">E-Mail-Benachrichtigungen</h3>
              <p className="text-zinc-600 mb-4">
                Bei Absenden einer Buchungsanfrage oder Kontaktanfrage erhalten Sie eine 
                Bestätigungs-E-Mail an die von Ihnen angegebene E-Mail-Adresse. Diese E-Mails 
                werden über den Dienst Resend (https://resend.com) versendet. Die Verarbeitung 
                erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO.
              </p>

              <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">
                4. Ihre Rechte
              </h2>
              <p className="text-zinc-600 mb-4">
                Sie haben jederzeit das Recht:
              </p>
              <ul className="list-disc list-inside text-zinc-600 mb-4">
                <li>Auskunft über Ihre bei uns gespeicherten Daten zu erhalten</li>
                <li>Berichtigung unrichtiger Daten zu verlangen</li>
                <li>Löschung Ihrer Daten zu verlangen</li>
                <li>Einschränkung der Verarbeitung zu verlangen</li>
                <li>Widerspruch gegen die Verarbeitung einzulegen</li>
                <li>Datenübertragbarkeit zu verlangen</li>
              </ul>
              <p className="text-zinc-600 mb-4">
                Zur Ausübung Ihrer Rechte kontaktieren Sie uns bitte unter: info@rentmich.at
              </p>

              <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">
                5. Beschwerderecht bei der Aufsichtsbehörde
              </h2>
              <p className="text-zinc-600">
                Sie haben das Recht, sich bei der zuständigen Aufsichtsbehörde zu beschweren. 
                In Österreich ist dies die Österreichische Datenschutzbehörde (DSB), 
                Barichgasse 40-42, 1030 Wien.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
